export function ProgressBar({
  pct,
  label,
}: {
  pct: number;
  label?: string;
}) {
  const clamped = Math.min(100, Math.max(0, pct));
  return (
    <div>
      {label && (
        <div className="mb-1 flex items-baseline justify-between text-sm">
          <span className="text-ink/70">{label}</span>
          <span className="font-semibold tabular-nums">{clamped}%</span>
        </div>
      )}
      <div
        className="h-2.5 w-full overflow-hidden rounded-full bg-ink/10"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="h-full rounded-full bg-grad-cta transition-[width] duration-500"
          style={{ width: `${clamped}%` }}
        />
      </div>
    </div>
  );
}
